// TODO -- common header names & values to checkout-utils
export const putRequestOptions = {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- predefined HTTP header name
  headers: { 'Content-Type': 'application/json' },
  method: 'PUT',
};
